<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div class="flex flex-col sm:flex-row sm:flex-wrap gap-2">
            <div>
                <select (change)="onSelectRelation()" [(ngModel)]="relationType" [class.text-zinc-400]="!relationType" id="inputRelation" class="min-w-48">
                    <option value="" class="text-zinc-400">All Relation</option>
                    <option value="fundingsource">Funding Source</option>
                    <option value="vendor">Vendor</option>
                </select>
            </div>
            <div class="min-w-48">
                <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date"
                    (ngModelChange)="onDateChange($event)" [owlDateTimeTrigger]="date" [selectMode]="'range'" />
                <owl-date-time [pickerType]="'calendar'" #date></owl-date-time>
            </div>
            <div>
                <select (change)="onFilterChange()" [(ngModel)]="paymentType" [class.text-zinc-400]="!paymentType" id="inputPaymentType" class="min-w-48">
                    <option value="" class="text-zinc-400">All Payment Types</option>
                    <option value="check">Check</option>
                    <option value="cash">Cash</option>
                </select>
            </div>
            <div *ngIf="relationType !== 'fundingsource'" class="min-w-48">
                <ng-select [(ngModel)]="company" (change)="onFilterChange()" [notFoundText]="'No record found'"
                    placeholder="All Vendors" [clearable]="false" [searchable]="true">
                    <ng-option [value]="''"><span class="text-zinc-400">All Vendors</span></ng-option>
                    <ng-option *ngFor="let item of companies" [value]="item.id">{{ item.name | titlecase }}</ng-option>
                </ng-select>
            </div>
            <div *ngIf="relationType !== 'vendor'" class="min-w-48">
                <ng-select [(ngModel)]="fundingSource" (change)="onFilterChange()" [notFoundText]="'No record found'"
                    placeholder="All Funding Sources" [clearable]="false" [searchable]="true">
                    <ng-option [value]="''"><span class="text-zinc-400">All Funding Sources</span></ng-option>
                    <ng-option *ngFor="let item of fundingSources" [value]="item.id">{{ item.title | titlecase }}</ng-option>
                </ng-select>
            </div>
        </div>
        <div *ngIf="manuals && manuals.length">
            <h1 class="text-xs text-nowrap text-left">Showing {{(numberOfRecords * currentPage) - (manuals.length != numberOfRecords ? (numberOfRecords - manuals.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>
        <div></div>
    </div>

    <div
        class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">#</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Transaction No</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Payment Type</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Batch</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Relation</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Notes</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Created At</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of manuals | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i=index"
                                    class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ (currentPage - 1) * numberOfRecords + i + 1 }}</td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ item.transaction_no || '' }}</td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ (item.paymentType | titlecase) || '' }}</td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ item.batch }}</td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ item.relation?.relationType === 'fundingsource' ? 'Funding Source' : (item.relation?.relationType === 'vendor' ? 'Vendor' : '') }}</td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ item.notes || '' }}</td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{ (item.createdAt | date:'MM/DD/YYYY hh:mm A') || '' }}</td>
                                </tr>
                                <tr *ngIf="loading">
                                    <td colspan="7" class="px-3 py-4 text-sm-light text-center">Loading...</td>
                                </tr>
                                <tr *ngIf="!loading && !manuals.length">
                                    <td colspan="7" class="px-3 py-4 text-sm-light text-center">No manual payments found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>

</section>
